export default "__VITE_ASSET__a63f8140__"